import { NONPAYMENT_DETAILS_DATA_REQUEST, 
        NONPAYMENT_DETAILS_DATA_FAILURE, 
        NONPAYMENT_DETAILS_DATA_SUCCESS,
        NONPAYMENT_DETAILS_DATA_LOADING,
        NONPAYMENT_TOP_REASON_DATA_REQUEST,
        NONPAYMENT_TOP_REASON_DATA_FAILURE,
        NONPAYMENT_TOP_REASON_DATA_LOADING,
        NONPAYMENT_TOP_REASON_DATA_SUCCESS,
        NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST,
        NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_LOADING,
        NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS,
        NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE,
        NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST,
        NONPAYMENT_CLAIMS_TREND_LOB_DATA_LOADING,
        NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS,
        NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE,
        NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST,
        NONPAYMENT_COMPLETE_AND_TREND_DATA_LOADING,
        NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS,
        NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE,
        NONPAYMENT_POLLING_STARTED,
        NONPAYMENT_POLLING_COMPLETED,
        NONPAYMENT_POLLING_FAILED,
        NONPAYMENT_POLLING_RESET,
        NONPAYMENT_DETAILS_DATA_CANCEL,
        NONPAYMENT_SUBCATEGORY_REQUEST,
        NONPAYMENT_SUBCATEGORY_SUCCESS,
        NONPAYMENT_SUBCATEGORY_FAILURE,
        NONPAYMENT_SUBCATEGORY_LOADING,
      } from "../actionTypes";


export const fetchNonPaymentDetailsRequest = (payload: any) => ({
    type: NONPAYMENT_DETAILS_DATA_REQUEST,
    payload,
  });
 
  export const fetchNonPaymentDetailsSuccess = (payload: any) => ({
    type: NONPAYMENT_DETAILS_DATA_SUCCESS,
    payload,
  });  

  export const fetchNonPaymentDetailsError = (payload: any) => ({
    type: NONPAYMENT_DETAILS_DATA_FAILURE,
    payload,
  });

  export const fetchNonPaymentDetailsLoading = (payload: any) => ({
    type: NONPAYMENT_DETAILS_DATA_LOADING,
    payload,
  });  

  export const fetchNonPaymentTopReasonRequest = (payload: any) => ({
    type: NONPAYMENT_TOP_REASON_DATA_REQUEST,
    payload,
  });

  export const fetchNonPaymentTopReasonLoading = (payload: any) => ({
    type: NONPAYMENT_TOP_REASON_DATA_LOADING,
    payload,
  });  
 
  export const fetchNonPaymentTopReasonSuccess = (payload: any) => ({
    type: NONPAYMENT_TOP_REASON_DATA_SUCCESS,
    payload,
  });  

  export const fetchNonPaymentTopReasonError = (payload: any) => ({
    type: NONPAYMENT_TOP_REASON_DATA_FAILURE,
    payload,
  });

  export const fetchNonPaymentClaimsGraphRequest = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST,
    payload,
  });

  export const fetchNonPaymentClaimsGraphLoading = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_LOADING,
    payload,
  });  
 
  export const fetchNonPaymentClaimsGraphSuccess = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS,
    payload,
  });  

  export const fetchNonPaymentClaimsGraphError = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE,
    payload,
  });

  export const fetchNonPaymentClaimsLOBRequest = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST,
    payload,
  });

  export const fetchNonPaymentClaimsLOBLoading = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_LOB_DATA_LOADING,
    payload,
  });  
 
  export const fetchNonPaymentClaimsLOBSuccess = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS,
    payload,
  });  

  export const fetchNonPaymentClaimsLOBError = (payload: any) => ({
    type: NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE,
    payload,
  });

  export const fetchNonPaymentCompleteandPartialRequest = (payload: any) => ({
    type: NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST,
    payload,
  });

  export const fetchNonPaymentCompleteandPartialLoading = (payload: any) => ({
    type: NONPAYMENT_COMPLETE_AND_TREND_DATA_LOADING,
    payload,
  });  
 
  export const fetchNonPaymentCompleteandPartialSuccess = (payload: any) => ({
    type: NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS,
    payload,
  });  

  export const fetchNonPaymentCompleteandPartialError = (payload: any) => ({
    type: NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE,
    payload,
  });

  export const nonPaymentPollingStarted = () => ({
  type: NONPAYMENT_POLLING_STARTED,
});

  export const nonPaymentPollingCompleted = () => ({
  type: NONPAYMENT_POLLING_COMPLETED,
});

  export const nonPaymentPollingFailed = () => ({
  type: NONPAYMENT_POLLING_FAILED,
});

  export const nonPaymentPollingReset = () => ({
  type: NONPAYMENT_POLLING_RESET,
});

export const cancelNonPaymentDetailsData = () => ({
  type: NONPAYMENT_DETAILS_DATA_CANCEL,
});

// On-demand subcategory fetch actions
export const fetchNonPaymentSubCategoryRequest = (payload: { categoryName: string; apiPayload: any }) => ({
  type: NONPAYMENT_SUBCATEGORY_REQUEST,
  payload,
});

export const fetchNonPaymentSubCategorySuccess = (payload: { categoryName: string; data: any }) => ({
  type: NONPAYMENT_SUBCATEGORY_SUCCESS,
  payload,
});

export const fetchNonPaymentSubCategoryFailure = (payload: { categoryName: string; error: any }) => ({
  type: NONPAYMENT_SUBCATEGORY_FAILURE,
  payload,
});

export const fetchNonPaymentSubCategoryLoading = (payload: { categoryName: string; loading: boolean }) => ({
  type: NONPAYMENT_SUBCATEGORY_LOADING,
  payload,
});